import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import rama2 from '../../../assets/rama2.png';
import rama1 from '../../../assets/rama1.png';
import { Sobre2 } from '../../../assets/icons';
import { getFontSize } from '../../../utils/getFont';

const BANK_DATA = {
  titular: 'Raquel Díaz Falero',
  titular2: 'Juan Gutiérrez Aguilera',
  iban: 'ES87 0049 4346 5026 1010 7359',
};

const Content = styled.div`
  position: relative;
  cursor: default;
  text-align: center;
  padding: 1rem;
  margin-top: 80px;

  p {
    font-family: var(--text-normal);
    ${getFontSize(3)}
    margin: 1rem 0;
  }

  .gift-options {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;

    h4 {
      ${getFontSize(4)}
      margin: 8px 0 5px;
    }
  }

  .bank-details {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .info {
      ${getFontSize(0)}
      opacity: 0.7;
      color: var(--text);
      margin-bottom: 8px;
    }
  }

  #IBAN {
    margin-top: 18px;
  }
`;

const BankRow = styled.div`
  display: flex;
  width: 100%;
  max-width: 450px;
  justify-content: center;
  align-items: flex-start;
  margin: 10px 0;
  text-align: left;
  gap: 12px;

  
  
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 4px;
  }
`;

const BankLabel = styled.span`
  font-weight: bold;
  font-family: var(--text-title);
  ${getFontSize(3)}
  min-width: 70px;
  text-align: right;
  
  @media (max-width: 480px) {
    text-align: center;
    width: 100%;
  }
`;

const BankValue = styled.div`
  display: flex;
  flex-direction: column;
  ${getFontSize(3)}
  flex: 1;

  .titulares, .iban {
    cursor: pointer;
    transition: opacity 0.2s;
    
    &:hover {
      opacity: 0.7;
      text-decoration: underline;
    }
  }

  .separator {
    font-size: 0.9em;
    opacity: 0.8;
    margin: 2px 0;
  }
`;

const Bank = () => {
  const handleCopy = (id, text) => {
    navigator.clipboard.writeText(text);

    // Mostrar un mensaje de confirmación si no hay ya otro
    const existingMessage = document.getElementById('copy-message');
    if (existingMessage) {
      existingMessage.remove();
    }

    const message = document.createElement('div');
    message.id = 'copy-message';
    message.innerText = id + ' copiado al portapapeles';
    message.style.position = 'absolute';
    message.style.top = '100%';
    message.style.left = '50%';
    message.style.whiteSpace = 'nowrap';
    message.style.transform = 'translateX(-50%)';
    message.style.background = 'var(--background-alt)';
    message.style.padding = '4px 16px';
    message.style.borderRadius = '8px';
    message.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.2)';
    message.style.zIndex = '1000';

    // Append to body or specific container to avoid positioning issues?
    // Original code appended to ID directly. We need to ensure ID exists on the element that has relative positioning or simply append to body if fixed.
    // However, existing code used `document.getElementById(id).appendChild(message)`.
    // We removed IDs 'Titular' and 'IBAN' from P tags. We should add them back to the BankRow or Value.

    // Correcting to find the closest relative container or just alert? 
    // Let's use a simpler approach or restore IDs.
    const target = document.getElementById(id);
    if (target) {
      target.appendChild(message);
    } else {
      // Fallback
      document.body.appendChild(message);
      message.style.position = 'fixed';
      message.style.top = '80%';
    }

    setTimeout(() => {
      message.remove();
    }, 2000);
  };

  return (
    <Content>
      <div className="gift-options">
        <Sobre2 color="#40101D" size={36} />
        <h4>Datos bancarios</h4>
        <div className="bank-details">

          <BankRow id="Titular" style={{ position: 'relative' }}>
            <BankLabel>Titulares:</BankLabel>
            <BankValue>
              <span className="titulares" onClick={() => handleCopy('Titular', BANK_DATA.titular)}>
                {BANK_DATA.titular}
              </span>
              <span className="separator">o</span>
              <span className="titulares" onClick={() => handleCopy('Titular', BANK_DATA.titular2)}>
                {BANK_DATA.titular2}
              </span>
            </BankValue>
          </BankRow>
          <div className="info">(Haz click en un nombre para copiar)</div>

          <BankRow id="IBAN" style={{ position: 'relative' }}>
            <BankLabel>IBAN:</BankLabel>
            <BankValue>
              <span className="iban" onClick={() => handleCopy('IBAN', BANK_DATA.iban)}>
                {BANK_DATA.iban}
              </span>
            </BankValue>
          </BankRow>
          <div className="info">(Haz click en el iban para copiar)</div>

        </div>
      </div>
    </Content>
  );
};

export default Bank;
